import React from 'react';

import { ContentLayout, MainBlockLayout } from '~/components/layouts';

const Index = (props) => {
	//const { user } = useGlobalState();

	return (
		<ContentLayout actions={[]}>
      <MainBlockLayout white>
				<h2 style={{ marginTop: 0 }}>Tanukin: Your Accounting Assistant in Japan</h2>
				<p>Are you a freelance in Japan? Are you struggling or losing time with tax-related stuff and would rather enjoy it, and even lower the amount of taxes you need to pay? Tanukin is here to help you at every step!</p>
				<h3>Ideas of Catching Sentences</h3>
				<ul>
					<li>Being a freelance in Japan is now easier than ever!</li>
					<li>You are probably paying too much taxes! Tanukin will help you making this fair to you.</li>
					<li>Keep an eye on your financials without having to use a bloated or complex software.</li>
				</ul>
			</MainBlockLayout>
		</ContentLayout>
	);

};

export default Index;
